/*
 * Copyright (c) 2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// This file is autogenerated by this script: packages/cp-shared-ui/scripts/populate-countries-cities-json.ts.

export const TIMEZONES_MAP = {
  'UTC+04:30 (Afghanistan Time)': 'Asia/Kabul',
  'UTC+02:00 (Eastern European Time)': 'Europe/Zaporozhye',
  'UTC+01:00 (Central European Time)': 'Europe/Vatican',
  'UTC-11:00 (Samoa Standard Time)': 'Pacific/Midway',
  'UTC+01:00 (West Africa Time)': 'Africa/Lagos',
  'UTC-04:00 (Atlantic Standard Time)': 'America/St_Thomas',
  'UTC-03:00 (Chile Summer Time)': 'America/Santiago',
  'UTC-03:00 (Rothera Research Station Time)': 'Antarctica/Rothera',
  'UTC±00 (Greenwich Mean Time)': 'Europe/London',
  'UTC+03:00 (Showa Station Time)': 'Antarctica/Syowa',
  'UTC+05:00 (Mawson Station Time)': 'Antarctica/Mawson',
  'UTC+06:00 (Vostok Station Time)': 'Antarctica/Vostok',
  'UTC+07:00 (Davis Time)': 'Antarctica/Davis',
  "UTC+10:00 (Dumont d'Urville Time)": 'Antarctica/DumontDUrville',
  'UTC+11:00 (Australian Western Standard Time)': 'Antarctica/Casey',
  'UTC+13:00 (New Zealand Daylight Time)': 'Pacific/Auckland',
  'UTC-03:00 (Argentina Time)': 'America/Argentina/Ushuaia',
  'UTC+04:00 (Armenia Time)': 'Asia/Yerevan',
  'UTC+08:00 (Australian Western Standard Time)': 'Australia/Perth',
  'UTC+08:45 (Australian Central Western Standard Time (Unofficial))': 'Australia/Eucla',
  'UTC+09:30 (Australian Central Standard Time)': 'Australia/Darwin',
  'UTC+10:00 (Australian Eastern Standard Time)': 'Australia/Lindeman',
  'UTC+10:30 (Australian Central Daylight Saving Time)': 'Australia/Broken_Hill',
  'UTC+11:00 (Macquarie Island Station Time)': 'Antarctica/Macquarie',
  'UTC+11:00 (Australian Eastern Daylight Saving Time)': 'Australia/Sydney',
  'UTC+11:00 (Lord Howe Summer Time)': 'Australia/Lord_Howe',
  'UTC+04:00 (Azerbaijan Time)': 'Asia/Baku',
  'UTC+03:00 (Arabia Standard Time)': 'Asia/Aden',
  'UTC+06:00 (Bangladesh Standard Time)': 'Asia/Dhaka',
  'UTC+03:00 (Moscow Time)': 'Europe/Simferopol',
  'UTC-06:00 (Central Standard Time (North America))': 'America/Belize',
  'UTC+06:00 (Bhutan Time)': 'Asia/Thimphu',
  'UTC-04:00 (Bolivia Time)': 'America/La_Paz',
  'UTC+02:00 (Central Africa Time)': 'Africa/Harare',
  'UTC-05:00 (Acre Time)': 'America/Rio_Branco',
  'UTC-04:00 (Amazon Time (Brazil)[3)': 'America/Porto_Velho',
  'UTC-04:00 (Brasilia Time)': 'America/Cuiaba',
  'UTC-04:00 (Amazon Time (Brazil))': 'America/Manaus',
  'UTC-03:00 (Brasília Time)': 'America/Sao_Paulo',
  'UTC-02:00 (Fernando de Noronha Time)': 'America/Noronha',
  'UTC+06:00 (Indian Ocean Time)': 'Indian/Chagos',
  'UTC+08:00 (Brunei Darussalam Time)': 'Asia/Brunei',
  'UTC+07:00 (Indochina Time)': 'Asia/Ho_Chi_Minh',
  'UTC-08:00 (Pacific Standard Time (North America)': 'America/Los_Angeles',
  'UTC-07:00 (Mountain Standard Time (North America))': 'America/Fort_Nelson',
  'UTC-07:00 (Mountain Standard Time (North America)': 'America/Phoenix',
  'UTC-06:00 (Central Standard Time (North America)': 'America/North_Dakota/New_Salem',
  'UTC-05:00 (Eastern Standard Time (North America))': 'America/Nassau',
  'UTC-05:00 (Eastern Standard Time (North America)': 'America/New_York',
  'UTC-03:30 (Newfoundland Standard Time)': 'America/St_Johns',
  'UTC-01:00 (Cape Verde Time)': 'Atlantic/Cape_Verde',
  'UTC-05:00 (Easter Island Summer Time)': 'Pacific/Easter',
  'UTC+06:00 (China Standard Time)': 'Asia/Urumqi',
  'UTC+08:00 (China Standard Time)': 'Asia/Taipei',
  'UTC+07:00 (Christmas Island Time)': 'Indian/Christmas',
  'UTC+06:30 (Cocos Islands Time)': 'Indian/Cocos',
  'UTC-05:00 (Colombia Time)': 'America/Bogota',
  'UTC+03:00 (East Africa Time)': 'Africa/Kampala',
  'UTC-10:00 (Cook Island Time)': 'Pacific/Rarotonga',
  'UTC-05:00 (Cuba Standard Time)': 'America/Havana',
  'UTC-06:00 (Galápagos Time)': 'Pacific/Galapagos',
  'UTC-05:00 (Ecuador Time)': 'America/Guayaquil',
  'UTC+02:00 (South African Standard Time)': 'Africa/Johannesburg',
  'UTC-03:00 (Falkland Islands Summer Time)': 'Atlantic/Stanley',
  'UTC±00 (Western European Time)': 'Atlantic/Canary',
  'UTC+12:00 (Fiji Time)': 'Pacific/Fiji',
  'UTC-03:00 (French Guiana Time)': 'America/Cayenne',
  'UTC-10:00 (Tahiti Time)': 'Pacific/Tahiti',
  'UTC-09:30 (Marquesas Islands Time)': 'Pacific/Marquesas',
  'UTC-09:00 (Gambier Islands Time)': 'Pacific/Gambier',
  'UTC+05:00 (French Southern and Antarctic Time)': 'Indian/Kerguelen',
  'UTC+04:00 (Georgia Standard Time)': 'Asia/Tbilisi',
  'UTC-03:00 (West Greenland Time)': 'America/Nuuk',
  'UTC-01:00 (Eastern Greenland Time)': 'America/Scoresbysund',
  'UTC+10:00 (Chamorro Standard Time)': 'Pacific/Saipan',
  'UTC-04:00 (Guyana Time)': 'America/Guyana',
  'UTC+08:00 (Hong Kong Time)': 'Asia/Hong_Kong',
  'UTC+05:30 (Indian Standard Time)': 'Asia/Colombo',
  'UTC+07:00 (Western Indonesian Time)': 'Asia/Pontianak',
  'UTC+08:00 (Central Indonesia Time)': 'Asia/Makassar',
  'UTC+09:00 (Eastern Indonesian Time)': 'Asia/Jayapura',
  'UTC+03:30 (Iran Daylight Time)': 'Asia/Tehran',
  'UTC+02:00 (Israel Standard Time)': 'Asia/Jerusalem',
  'UTC+09:00 (Japan Standard Time)': 'Asia/Tokyo',
  'UTC+05:00 (Aqtobe Time)': 'Asia/Aqtobe',
  'UTC+05:00 (Moscow Daylight Time+1)': 'Asia/Atyrau',
  'UTC+05:00 (Oral Time)': 'Asia/Oral',
  'UTC+05:00 (Qyzylorda Summer Time)': 'Asia/Qyzylorda',
  'UTC+06:00 (Alma-Ata Time[1)': 'Asia/Almaty',
  'UTC+06:00 (Qyzylorda Summer Time)': 'Asia/Qostanay',
  'UTC+12:00 (Gilbert Island Time)': 'Pacific/Tarawa',
  'UTC+13:00 (Phoenix Island Time)': 'Pacific/Enderbury',
  'UTC+14:00 (Line Islands Time)': 'Pacific/Kiritimati',
  'UTC+06:00 (Kyrgyzstan Time)': 'Asia/Bishkek',
  'UTC+08:00 (Malaysia Time)': 'Asia/Kuching',
  'UTC+05:00 (Maldives Time)': 'Indian/Maldives',
  'UTC+12:00 (Marshall Islands Time)': 'Pacific/Majuro',
  'UTC+04:00 (Mauritius Time)': 'Indian/Mauritius',
  'UTC+10:00 (Chuuk Time)': 'Pacific/Chuuk',
  'UTC+11:00 (Kosrae Time)': 'Pacific/Kosrae',
  'UTC+11:00 (Pohnpei Standard Time)': 'Pacific/Pohnpei',
  'UTC+07:00 (Hovd Time)': 'Asia/Hovd',
  'UTC+08:00 (Choibalsan Standard Time)': 'Asia/Choibalsan',
  'UTC+08:00 (Ulaanbaatar Standard Time)': 'Asia/Ulaanbaatar',
  'UTC+01:00 (Western European Summer Time)': 'Africa/El_Aaiun',
  'UTC+01:00 (Western Sahara Time)': 'Africa/El_Aaiun',
  'UTC+06:30 (Myanmar Standard Time)': 'Asia/Yangon',
  'UTC+02:00 (West Africa Summer Time)': 'Africa/Windhoek',
  'UTC+12:00 (Nauru Time)': 'Pacific/Nauru',
  'UTC+05:45 (Nepal Time)': 'Asia/Kathmandu',
  'UTC+11:00 (New Caledonia Time)': 'Pacific/Noumea',
  'UTC+13:45 (Chatham Standard Time)': 'Pacific/Chatham',
  'UTC-11:00 (Niue Time)': 'Pacific/Niue',
  'UTC+12:00 (Norfolk Time)': 'Pacific/Norfolk',
  'UTC+09:00 (Korea Standard Time)': 'Asia/Seoul',
  'UTC+04:00 (Gulf Standard Time)': 'Asia/Dubai',
  'UTC+05:00 (Pakistan Standard Time)': 'Asia/Karachi',
  'UTC+09:00 (Palau Time)': 'Pacific/Palau',
  'UTC+10:00 (Papua New Guinea Time)': 'Pacific/Port_Moresby',
  'UTC+11:00 (Bougainville Standard Time[6)': 'Pacific/Bougainville',
  'UTC-03:00 (Paraguay Summer Time)': 'America/Asuncion',
  'UTC-05:00 (Peru Time)': 'America/Lima',
  'UTC+08:00 (Philippine Time)': 'Asia/Manila',
  'UTC-01:00 (Azores Standard Time)': 'Atlantic/Azores',
  'UTC+04:00 (Réunion Time)': 'Indian/Reunion',
  'UTC+04:00 (Samara Time)': 'Europe/Ulyanovsk',
  'UTC+04:00 (Moscow Daylight Time+4)': 'Europe/Saratov',
  'UTC+04:00 (Moscow Standard Time)': 'Europe/Volgograd',
  'UTC+05:00 (Yekaterinburg Time)': 'Asia/Yekaterinburg',
  'UTC+06:00 (Omsk Time)': 'Asia/Omsk',
  'UTC+07:00 (Krasnoyarsk Time)': 'Asia/Novokuznetsk',
  'UTC+07:00 (Novosibirsk Time)': 'Asia/Novosibirsk',
  'UTC+07:00 (Moscow Daylight Time+3)': 'Asia/Tomsk',
  'UTC+08:00 (Irkutsk Time)': 'Asia/Irkutsk',
  'UTC+09:00 (Yakutsk Time)': 'Asia/Yakutsk',
  'UTC+10:00 (Vladivostok Time)': 'Asia/Vladivostok',
  'UTC+11:00 (Magadan Time)': 'Asia/Magadan',
  'UTC+11:00 (Sakhalin Island Time)': 'Asia/Sakhalin',
  'UTC+11:00 (Srednekolymsk Time)': 'Asia/Srednekolymsk',
  'UTC+12:00 (Anadyr Time[4)': 'Asia/Anadyr',
  'UTC+12:00 (Kamchatka Time)': 'Asia/Kamchatka',
  'UTC-03:00 (Pierre & Miquelon Daylight Time)': 'America/Miquelon',
  'UTC+14:00 (West Samoa Time)': 'Pacific/Apia',
  'UTC+04:00 (Seychelles Time)': 'Indian/Mahe',
  'UTC+08:00 (Singapore Time)': 'Asia/Singapore',
  'UTC+11:00 (Solomon Islands Time)': 'Pacific/Guadalcanal',
  'UTC-02:00 (South Georgia and the South Sandwich Islands Time)': 'Atlantic/South_Georgia',
  'UTC+02:00 (Eastern African Time)': 'Africa/Khartoum',
  'UTC-03:00 (Suriname Time)': 'America/Paramaribo',
  'UTC+05:00 (Tajikistan Time)': 'Asia/Dushanbe',
  'UTC+09:00 (Timor Leste Time)': 'Asia/Dili',
  'UTC+13:00 (Tokelau Time)': 'Pacific/Fakaofo',
  'UTC+13:00 (Tonga Time)': 'Pacific/Tongatapu',
  'UTC+03:00 (Eastern European Time)': 'Europe/Istanbul',
  'UTC+05:00 (Turkmenistan Time)': 'Asia/Ashgabat',
  'UTC+12:00 (Tuvalu Time)': 'Pacific/Funafuti',
  'UTC-10:00 (Hawaii–Aleutian Standard Time)': 'Pacific/Honolulu',
  'UTC-09:00 (Alaska Standard Time)': 'America/Yakutat',
  'UTC+12:00 (Wake Island Time)': 'Pacific/Wake',
  'UTC-03:00 (Uruguay Standard Time)': 'America/Montevideo',
  'UTC+05:00 (Uzbekistan Time)': 'Asia/Tashkent',
  'UTC+11:00 (Vanuatu Time)': 'Pacific/Efate',
  'UTC-04:00 (Venezuelan Standard Time)': 'America/Caracas',
  'UTC+12:00 (Wallis & Futuna Time)': 'Pacific/Wallis'
}
